module.exports = __webpack_public_path__ + "static/media/dot-menu-white.60c58ad5.svg";